// @flow

import React from 'react';
import { links } from 'core/config/index';
import { jobs as t } from 'helpers/translation';
import BtnXs from 'components/BtnXs';

type Props = {
  isCurrentUser: boolean,
  toggleVisibility: Function,
  showInput: boolean
};

export default ({ isCurrentUser, toggleVisibility, showInput }: Props) => {
  const handleClick = () => {
    if (!showInput) {
      toggleVisibility('input');
    } else window.scrollTo({ left: 0, top: 0 });
  };

  return(
    <div className="card card_inquiry card_wide">
      <div className="card__info">
        <div className="card__title">{t.bottom_card.title}</div>
        <div className="card__desc">{t.bottom_card.description}</div>
      </div>
      <BtnXs
        text={t.btn.add_job_alert}
        type="primary"
        handleClick={() => handleClick()}
        href={!isCurrentUser ? links.login : ''}
        classes="btn_add"
      />
    </div>
  );
};
